import PropTypes from 'prop-types';
import React from 'react';

const TestcardSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 35}`}
      height={`${height || 24}`}
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke={color || '#D9D9D9'} />
    </svg>
  );
};

TestcardSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default TestcardSvg;
